"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiPopover = require("@tencent/spaui-popover");

var _data = require("../config/data");

var _datepicker_compact_props = _interopRequireDefault(require("../datepicker_compact_props"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var WeekPanel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(WeekPanel, _PureComponent);

  function WeekPanel(props) {
    var _this;

    _classCallCheck(this, WeekPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WeekPanel).call(this, props));
    _this.state = {
      selectDate: '',
      selectStartDate: '',
      // 多选开始日期
      selectEndDate: '',
      // 多选结束日期
      hoverWeekDays: [],
      // 鼠标hover需要展示的天数
      showTips: false
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  } // 初始化相关的time


  _createClass(WeekPanel, [{
    key: "getTimeInfo",
    value: function getTimeInfo() {
      var _this$props = this.props,
          optionalStartDateData = _this$props.optionalStartDateData,
          optionalEndDateData = _this$props.optionalEndDateData,
          _this$props$startData = _this$props.startData,
          startData = _this$props$startData === void 0 ? {} : _this$props$startData,
          _this$props$endData = _this$props.endData,
          endData = _this$props$endData === void 0 ? {} : _this$props$endData;
      var optionalStartDateTime = new Date(optionalStartDateData.year, optionalStartDateData.month, optionalStartDateData.date).getTime();
      var optionalEndDateTime = new Date(optionalEndDateData.year, optionalEndDateData.month, optionalEndDateData.date).getTime();
      var _startData$year = startData.year,
          startYear = _startData$year === void 0 ? 0 : _startData$year,
          _startData$month = startData.month,
          startMonth = _startData$month === void 0 ? 0 : _startData$month,
          _startData$date = startData.date,
          startDate = _startData$date === void 0 ? 0 : _startData$date;
      var _endData$year = endData.year,
          endYear = _endData$year === void 0 ? 0 : _endData$year,
          _endData$month = endData.month,
          endMonth = _endData$month === void 0 ? 0 : _endData$month,
          _endData$date = endData.date,
          endDate = _endData$date === void 0 ? 0 : _endData$date;
      var startDateTime = new Date(startYear, startMonth, startDate).getTime();
      var endDateTime = new Date(endYear, endMonth, endDate).getTime();
      return {
        optionalStartDateTime: optionalStartDateTime,
        optionalEndDateTime: optionalEndDateTime,
        startDateTime: startDateTime,
        endDateTime: endDateTime
      };
    } // 当前日期是否能用

  }, {
    key: "canUse",
    value: function canUse(year, month, date) {
      var _compactProps = (0, _datepicker_compact_props["default"])(this.props),
          type = _compactProps.type,
          startDateDisabled = _compactProps.startDateDisabled,
          endDateDisabled = _compactProps.endDateDisabled,
          _compactProps$startDa = _compactProps.startData,
          startData = _compactProps$startDa === void 0 ? {} : _compactProps$startDa,
          _compactProps$endData = _compactProps.endData,
          endData = _compactProps$endData === void 0 ? {} : _compactProps$endData,
          shortestRange = _compactProps.shortestRange,
          longestRange = _compactProps.longestRange,
          startDateCanBeUnlimited = _compactProps.startDateCanBeUnlimited,
          unlimitedDateValue = _compactProps.unlimitedDateValue,
          format = _compactProps.format,
          getDateValue = _compactProps.getDateValue,
          optionalStartDateData = _compactProps.optionalStartDateData,
          optionalEndDateData = _compactProps.optionalEndDateData,
          endDateCanBeUnlimited = _compactProps.endDateCanBeUnlimited;

      var _this$getTimeInfo = this.getTimeInfo(),
          optionalStartDateTime = _this$getTimeInfo.optionalStartDateTime,
          optionalEndDateTime = _this$getTimeInfo.optionalEndDateTime,
          startDateTime = _this$getTimeInfo.startDateTime,
          endDateTime = _this$getTimeInfo.endDateTime;

      var currentDateTime = new Date(year, month, date).getTime();

      var theTimeInRange = function theTimeInRange() {
        var beginTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var endTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return currentDateTime >= beginTime && currentDateTime <= endTime;
      };

      var result = true;
      var tempData = {};
      var spaceTime = 0; // 小于可选日期肯定都不能用了

      if (!theTimeInRange(optionalStartDateTime, optionalEndDateTime)) {
        result = false;
      } else {
        // 开始日期禁止变更的情况
        if (startDateDisabled) {
          // 禁止开始日期
          if (!theTimeInRange(startDateTime + _data.ONE_DAY_TIME * shortestRange, startDateTime + _data.ONE_DAY_TIME * longestRange)) {
            result = false;
          }
        } // 结束日期禁止变更的情况


        if (result && endDateDisabled) {
          // 禁止开始日期
          if (!theTimeInRange(endDateTime - _data.ONE_DAY_TIME * longestRange, endDateTime - _data.ONE_DAY_TIME * shortestRange)) {
            result = false;
          }
        } // 选择一个日期后，不能保证在选择范围的，都是false


        if ((type === 'start' || type === 'end') && result) {
          if (startData.year && !endData.year || endData.year && !startData.year) {
            if (startData.year) {
              // 如果开始日期是无限的，那就用可选开始日期作为判断依据
              if (startDateCanBeUnlimited && (0, _spauiUtils.joinDate)(startData, format) === getDateValue('startDate', unlimitedDateValue)) {
                tempData = optionalStartDateData;
              } else {
                tempData = startData;
              }
            } else {
              // 如果开始日期是无限的，那就用可选开始日期作为判断依据
              if (endDateCanBeUnlimited && (0, _spauiUtils.joinDate)(endData, format) === getDateValue('endDate', unlimitedDateValue)) {
                tempData = optionalEndDateData;
              } else {
                tempData = endData;
              }
            }

            spaceTime = Math.abs(currentDateTime - new Date(tempData.year, tempData.month, tempData.date).getTime());

            if (shortestRange > 0 && spaceTime < shortestRange * _data.ONE_DAY_TIME) {
              result = false;
            } else if (longestRange > 0 && spaceTime > longestRange * _data.ONE_DAY_TIME) {
              result = false;
            }
          }
        }
      }

      return result;
    } // 比较两个时间是否相等

  }, {
    key: "compareDate",
    value: function compareDate(dateA, dateB) {
      return new Date((0, _utils.formatDate)(dateA)).getTime() - new Date((0, _utils.formatDate)(dateB)).getTime();
    } // 单选边角设定

  }, {
    key: "borderSingle",
    value: function borderSingle(data, currentDate, selectDate, currentWeekDays, hoverWeekDays) {
      var _this2 = this;

      var currentDateData = data;
      var realEndWeeks = currentWeekDays.filter(function (item) {
        return _this2.compareDate(item, new Date()) <= 0;
      });
      var currentDayOfWeek = new Date(currentDate).getDay();

      var _this$getTimeInfo2 = this.getTimeInfo(),
          optionalStartDateTime = _this$getTimeInfo2.optionalStartDateTime,
          optionalEndDateTime = _this$getTimeInfo2.optionalEndDateTime;

      var minDate = (0, _utils.formatDate)(new Date(optionalStartDateTime));
      var maxDate = (0, _utils.formatDate)(new Date(optionalEndDateTime));
      currentDateData.needLeftRadius = currentDayOfWeek === 0 || this.compareDate(currentDate, hoverWeekDays[0]) === 0 || this.compareDate(currentDate, selectDate) === 0 && this.compareDate(selectDate, currentWeekDays[0]) <= 0 || this.compareDate(currentDate, minDate) === 0 || this.compareDate(currentDate, currentWeekDays[0]) === 0;
      currentDateData.needRightRadius = currentDayOfWeek === 6 || this.compareDate(currentDate, hoverWeekDays[hoverWeekDays.length - 1]) === 0 || this.compareDate(currentDate, selectDate) === 0 && this.compareDate(selectDate, realEndWeeks[realEndWeeks.length - 1]) === 0 || this.compareDate(currentDate, maxDate) === 0 || this.compareDate(currentDate, realEndWeeks[realEndWeeks.length - 1]) === 0;
      return currentDateData;
    }
  }, {
    key: "highLightItem",
    value: function highLightItem(currentDate, selectStartDate, selectEndDate, data, isUnlimited, unlimitedDateValue) {
      var _this$props2 = this.props,
          startWeek = _this$props2.firstDayOfWeek,
          endWeek = _this$props2.endDayOfWeek;
      var hoverWeekDays = this.state.hoverWeekDays;

      var _this$getTimeInfo3 = this.getTimeInfo(),
          optionalStartDateTime = _this$getTimeInfo3.optionalStartDateTime,
          optionalEndDateTime = _this$getTimeInfo3.optionalEndDateTime;

      var minDate = (0, _utils.formatDate)(new Date(optionalStartDateTime));
      var maxDate = (0, _utils.formatDate)(new Date(optionalEndDateTime));
      var currentDateData = data;
      var startWeekDays = (0, _utils.getCurrentWeekDays)(selectStartDate, startWeek, endWeek);
      var endWeekDays = (0, _utils.getCurrentWeekDays)(selectEndDate, startWeek, endWeek);
      var currentDayOfWeek = new Date(currentDate).getDay(); // 是否需要切圆角

      currentDateData.needLeftRadius = currentDayOfWeek === 0 || this.compareDate(currentDate, hoverWeekDays[0]) === 0 || this.compareDate(currentDate, minDate) === 0 || this.compareDate(currentDate, startWeekDays[0]) === 0;
      currentDateData.needRightRadius = currentDayOfWeek === 6 || this.compareDate(currentDate, hoverWeekDays[hoverWeekDays.length - 1]) === 0 || this.compareDate(currentDate, maxDate) === 0 || this.compareDate(currentDate, endWeekDays[endWeekDays.length - 1]) === 0;

      if (isUnlimited) {
        currentDateData.on = !currentDateData.disabled && (startWeekDays.includes(currentDate) || (0, _utils.getCurrentWeekDays)(unlimitedDateValue, startWeek, endWeek).includes(currentDate));
      } else {
        var rangeWeekDays = (0, _utils.getRangeWeekDays)(selectStartDate, selectEndDate, startWeek, endWeek, true);
        currentDateData.on = startWeekDays.includes(currentDate) || endWeekDays.includes(currentDate) || rangeWeekDays.includes(currentDate);
      }

      return currentDateData;
    } // 高亮选中一周的天数

  }, {
    key: "highlightWeek",
    value: function highlightWeek(type, year, month, day, data, noHighLight) {
      var currentDate = (0, _utils.formatDate)(new Date(year, month, day));
      var _this$props3 = this.props,
          startWeek = _this$props3.firstDayOfWeek,
          endWeek = _this$props3.endDayOfWeek,
          fixedNumber = _this$props3.fixedNumber,
          unlimitedDateValue = _this$props3.unlimitedDateValue;
      var _this$state = this.state,
          selectDate = _this$state.selectDate,
          selectStartDate = _this$state.selectStartDate,
          selectEndDate = _this$state.selectEndDate,
          hoverWeekDays = _this$state.hoverWeekDays;
      var currentDateData = data;
      currentDateData.on = selectDate === currentDate;
      delete currentDateData.among;
      var isUnlimited = this.compareDate(selectEndDate, unlimitedDateValue) > 0; // 是否是无限日期

      if (!data.disabled && !noHighLight) {
        if (type === 'single') {
          if (fixedNumber) {
            var defaultStartDate;
            var defaultEndDate;

            if (fixedNumber > 0) {
              defaultStartDate = selectDate;
              defaultEndDate = (0, _utils.getLastWeekByNumber)(selectDate, fixedNumber);
            } else {
              defaultStartDate = (0, _utils.getLastWeekByNumber)(selectDate, fixedNumber);
              defaultEndDate = selectDate;
            }

            currentDateData = this.highLightItem(currentDate, defaultStartDate, defaultEndDate, currentDateData, isUnlimited, unlimitedDateValue);
          } else {
            var currentWeekDays = (0, _utils.getCurrentWeekDays)(selectDate, startWeek, endWeek);
            currentDateData.on = currentDateData.on || currentWeekDays.includes(currentDate);
            currentDateData = this.borderSingle(currentDateData, currentDate, selectDate, currentWeekDays, hoverWeekDays);
          }
        } else {
          currentDateData = this.highLightItem(currentDate, selectStartDate, selectEndDate, currentDateData, isUnlimited, unlimitedDateValue);
        }
      }

      currentDateData.tips = "".concat((0, _utils.getWeekOfYearByDate)(currentDate, startWeek, endWeek), "\u5468");
      currentDateData.hover = hoverWeekDays.length > 0 && hoverWeekDays.includes(currentDate) && !currentDateData.disabled; // 屏蔽所选日期在【startWeek, endWeek] 以外的日期。比如[1,5] 屏蔽掉周六周日

      var dayOfWeek = new Date(currentDate).getDay();
      var currentDay = dayOfWeek === 0 ? 7 : dayOfWeek; // 0 周日

      currentDateData.hideWeek = endWeek >= startWeek && (currentDay > endWeek || currentDay < startWeek);

      if (currentDateData.hideWeek || currentDateData.disabled) {
        var disableWeekDays = [];
        disableWeekDays.push(currentDate);
        currentDateData.disableWeekDays = disableWeekDays;
        currentDateData.on = false;
      }

      currentDateData.popoverRight = currentDateData.hover && new Date(currentDate).getDay() === 6;
      return currentDateData;
    } // 获取上个月的日期数据

  }, {
    key: "getLastMonthDateData",
    value: function getLastMonthDateData(year, month) {
      var _this$props4 = this.props,
          type = _this$props4.type,
          _this$props4$startDat = _this$props4.startData,
          startData = _this$props4$startDat === void 0 ? {} : _this$props4$startDat,
          _this$props4$endData = _this$props4.endData,
          endData = _this$props4$endData === void 0 ? {} : _this$props4$endData,
          propsStartYear = _this$props4.startYear,
          propsStartMonth = _this$props4.startMonth,
          hideEndDatePanel = _this$props4.hideEndDatePanel,
          panelWeekStart = _this$props4.panelWeekStart;
      var _startData$year2 = startData.year,
          startYear = _startData$year2 === void 0 ? 0 : _startData$year2,
          _startData$month2 = startData.month,
          startMonth = _startData$month2 === void 0 ? 0 : _startData$month2,
          _startData$date2 = startData.date,
          startDate = _startData$date2 === void 0 ? 0 : _startData$date2;
      var _endData$year2 = endData.year,
          endYear = _endData$year2 === void 0 ? 0 : _endData$year2,
          _endData$month2 = endData.month,
          endMonth = _endData$month2 === void 0 ? 0 : _endData$month2,
          _endData$date2 = endData.date,
          endDate = _endData$date2 === void 0 ? 0 : _endData$date2;
      var weekDate = new Date(year, month, 1);
      var firstDayOfWeek = weekDate.getDay();

      var _this$getTimeInfo4 = this.getTimeInfo(),
          startDateTime = _this$getTimeInfo4.startDateTime,
          endDateTime = _this$getTimeInfo4.endDateTime;

      var result = [];
      var lastMonthDays = 0;
      var lastYear = 0;
      var lastMonth = 0;
      var lastDate = 0;
      var currentDateData = {};
      var currentDateTime = 0; // 如果这个月第一天的日期恰好不是指定的周的起始，则需要补充上个月的日期

      if (firstDayOfWeek > panelWeekStart) {
        // 获得上一个月的年与月信息
        if (month === 0) {
          lastYear = year - 1;
          lastMonth = 11;
        } else {
          lastYear = year;
          lastMonth = month - 1;
        } // 上个月有多少天


        lastMonthDays = new Date(lastYear, lastMonth + 1, 0).getDate(); // 需要补充上个月的天数

        var appendDayNumber = firstDayOfWeek - panelWeekStart;

        for (var i = 0; i < appendDayNumber; i++) {
          // 上个月对应的某一天
          lastDate = lastMonthDays - i;
          currentDateData = {
            lastMonth: true,
            disabled: !this.canUse(lastYear, lastMonth, lastDate),
            year: lastYear,
            month: lastMonth,
            date: lastDate
          }; // 另外个面板不是上个月才做选中展示

          if (type === 'end' && !(lastYear === propsStartYear && lastMonth === propsStartMonth) || type === 'start' || hideEndDatePanel) {
            // 处于选中时间的中间过程
            if (Math.abs(startDateTime) > 0 && endDateTime > 0) {
              currentDateTime = new Date(lastYear, lastMonth, lastDate).getTime();

              if (currentDateTime > startDateTime && currentDateTime < endDateTime) {
                currentDateData.among = true;
              }
            } // 开始日期选中


            if (lastYear === startYear && lastMonth === startMonth && lastDate === startDate) {
              delete currentDateData.among;
              currentDateData.startDate = true;
              currentDateData.on = true;
            } // 结束日期选中


            if (lastYear === endYear && lastMonth === endMonth && lastDate === endDate) {
              delete currentDateData.among;
              currentDateData.endDate = true;
              currentDateData.on = true;
            }
          }

          result.unshift(this.highlightWeek(type, lastYear, lastMonth, lastDate, currentDateData));
        }
      }

      return result;
    } // 获取下个月的日期

  }, {
    key: "getNextMonthDateData",
    value: function getNextMonthDateData(year, month) {
      var len = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var _this$props5 = this.props,
          type = _this$props5.type,
          _this$props5$startDat = _this$props5.startData,
          startData = _this$props5$startDat === void 0 ? {} : _this$props5$startDat,
          _this$props5$endData = _this$props5.endData,
          endData = _this$props5$endData === void 0 ? {} : _this$props5$endData,
          hideEndDatePanel = _this$props5.hideEndDatePanel,
          propsEndYear = _this$props5.endYear,
          propsEndMonth = _this$props5.endMonth;
      var _startData$year3 = startData.year,
          startYear = _startData$year3 === void 0 ? 0 : _startData$year3,
          _startData$month3 = startData.month,
          startMonth = _startData$month3 === void 0 ? 0 : _startData$month3,
          _startData$date3 = startData.date,
          startDate = _startData$date3 === void 0 ? 0 : _startData$date3;
      var _endData$year3 = endData.year,
          endYear = _endData$year3 === void 0 ? 0 : _endData$year3,
          _endData$month3 = endData.month,
          endMonth = _endData$month3 === void 0 ? 0 : _endData$month3,
          _endData$date3 = endData.date,
          endDate = _endData$date3 === void 0 ? 0 : _endData$date3;

      var _this$getTimeInfo5 = this.getTimeInfo(),
          startDateTime = _this$getTimeInfo5.startDateTime,
          endDateTime = _this$getTimeInfo5.endDateTime;

      var result = [];
      var i = 0;
      var nextYear = 0;
      var nextMonth = 0;
      var nextDate = 0;
      var currentDateData = {};
      var currentDateTime = 0;

      if (len > 0) {
        // 获得上一个月的年与月信息
        if (month === 11) {
          nextYear = year + 1;
          nextMonth = 0;
        } else {
          nextYear = year;
          nextMonth = month + 1;
        }

        for (; i < len; i++) {
          nextDate = i + 1;
          currentDateData = {
            nextMonth: true,
            year: nextYear,
            month: nextMonth,
            disabled: !this.canUse(nextYear, nextMonth, nextDate),
            date: nextDate
          }; // 另外个面板不是下个月才做选中展示

          if (type === 'start' && !(nextYear === propsEndYear && nextMonth === propsEndMonth) || type === 'end' || hideEndDatePanel) {
            // 处于选中时间的中间过程
            if (Math.abs(startDateTime) > 0 && endDateTime > 0) {
              currentDateTime = new Date(nextYear, nextMonth, nextDate).getTime();

              if (currentDateTime > startDateTime && currentDateTime < endDateTime) {
                currentDateData.among = true;
              }
            } // 开始日期选中


            if (nextYear === startYear && nextMonth === startMonth && i === startDate - 1) {
              delete currentDateData.among;
              currentDateData.startDate = true;
              currentDateData.on = true;
            } // 结束日期选中


            if (nextYear === endYear && nextMonth === endMonth && i === endDate - 1) {
              delete currentDateData.among;
              currentDateData.endDate = true;
              currentDateData.on = true;
            }
          }

          result.push(this.highlightWeek(type, nextYear, nextMonth, nextDate, currentDateData));
        }
      }

      return result;
    } // 获取日期数据

  }, {
    key: "getData",
    value: function getData() {
      var _this$props6 = this.props,
          year = _this$props6.year,
          _this$props6$month = _this$props6.month,
          month = _this$props6$month === void 0 ? 0 : _this$props6$month,
          _this$props6$dateData = _this$props6.dateData,
          dateData = _this$props6$dateData === void 0 ? {} : _this$props6$dateData,
          _this$props6$startDat = _this$props6.startData,
          startData = _this$props6$startDat === void 0 ? {} : _this$props6$startDat,
          _this$props6$endData = _this$props6.endData,
          endData = _this$props6$endData === void 0 ? {} : _this$props6$endData,
          type = _this$props6.type,
          hoverYear = _this$props6.hoverYear,
          hoverMonth = _this$props6.hoverMonth,
          hoverDate = _this$props6.hoverDate;
      var _dateData$year = dateData.year,
          singleYear = _dateData$year === void 0 ? 0 : _dateData$year,
          singleMonth = dateData.month,
          _dateData$date = dateData.date,
          singleDate = _dateData$date === void 0 ? 0 : _dateData$date;
      var _startData$year4 = startData.year,
          startYear = _startData$year4 === void 0 ? 0 : _startData$year4,
          _startData$month4 = startData.month,
          startMonth = _startData$month4 === void 0 ? 0 : _startData$month4,
          _startData$date4 = startData.date,
          startDate = _startData$date4 === void 0 ? 0 : _startData$date4;
      var _endData$year4 = endData.year,
          endYear = _endData$year4 === void 0 ? 0 : _endData$year4,
          _endData$month4 = endData.month,
          endMonth = _endData$month4 === void 0 ? 0 : _endData$month4,
          _endData$date4 = endData.date,
          endDate = _endData$date4 === void 0 ? 0 : _endData$date4;

      var _this$getTimeInfo6 = this.getTimeInfo(),
          startDateTime = _this$getTimeInfo6.startDateTime,
          endDateTime = _this$getTimeInfo6.endDateTime;

      if (type !== 'single') {
        this.setState({
          selectStartDate: (0, _utils.formatDate)(new Date(startDateTime)),
          selectEndDate: (0, _utils.formatDate)(new Date(endDateTime))
        });
      }

      var currentDateTime = 0;
      var i = 0;
      var days = 0;
      var currentDateData = {};
      var result = []; // 上个月的日期

      result = this.getLastMonthDateData(year, month); // 这个月的日期，都为可用数据

      i = 0;
      days = new Date(year, month + 1, 0).getDate();

      for (; i < days; i++) {
        currentDateData = {
          year: year,
          month: month,
          disabled: !this.canUse(year, month, i + 1),
          date: i + 1
        };

        if (type === 'single') {
          // 开始日期选中
          if (year === singleYear && month === singleMonth && i === singleDate - 1) {
            currentDateData.on = true;
            this.setState({
              selectDate: (0, _utils.formatDate)(new Date(singleYear, singleMonth, singleDate))
            });
          }
        } else if (type === 'start' || type === 'end') {
          // 处于选中时间的中间过程
          if (Math.abs(startDateTime) > 0 && endDateTime > 0) {
            currentDateTime = new Date(year, month, i + 1).getTime();

            if (currentDateTime > startDateTime && currentDateTime < endDateTime) {
              currentDateData.among = true;
            }
          } // 开始日期选中


          if (year === startYear && month === startMonth && i === startDate - 1) {
            delete currentDateData.among;
            currentDateData.startDate = true;
            currentDateData.on = true;
            this.setState({
              selectStartDate: (0, _utils.formatDate)(new Date(year, month, i + 1))
            });
          } // 结束日期选中


          if (year === endYear && month === endMonth && i === endDate - 1) {
            delete currentDateData.among;
            currentDateData.endDate = true;
            currentDateData.on = true;
            this.setState({
              selectEndDate: (0, _utils.formatDate)(new Date(year, month, i + 1))
            });
          } // 只选中了起始日期，结束日期未选中, 或者选中了结束日期，起始日期未选中


          var startIsZero = startYear === 0 && startMonth === 0 && startDate === 0;
          var endIsZero = endYear === 0 && endMonth === 0 && endDate === 0;

          if (!startIsZero && endIsZero) {
            // 选中的开始日期到鼠标 hover 日期之前的过程
            if (Math.abs(startDateTime) > 0) {
              currentDateTime = new Date(year, month, i + 1).getTime();
              var hoverDateTime = new Date(hoverYear, hoverMonth, hoverDate).getTime();
              var lessHoverDateTime = currentDateTime > startDateTime && currentDateTime < hoverDateTime;
              var moreHoverDateTime = currentDateTime < startDateTime && currentDateTime > hoverDateTime;

              if (lessHoverDateTime || moreHoverDateTime) {
                if (this.canUse(year, month, i + 1)) {
                  currentDateData.among = true;
                }
              }
            }
          }
        }

        result.push(this.highlightWeek(type, year, month, i + 1, currentDateData));
      } // 下个月的日期，固定6行，剩下的由下个月的补齐


      result = result.concat(this.getNextMonthDateData(year, month, 42 - result.length));
      return result;
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props7 = this.props,
          onChange = _this$props7.onChange,
          type = _this$props7.type,
          onYearAndMonthChange = _this$props7.onYearAndMonthChange;
      var disabled = data.disabled,
          hideWeek = data.hideWeek; // 获取界面上可点选择的元素

      var disableWeekDays = this.getData().filter(function (item) {
        return item.disableWeekDays;
      }).map(function (_ref) {
        var year = _ref.year,
            month = _ref.month,
            date = _ref.date;
        return (0, _utils.formatDate)(new Date(year, month, date));
      });

      if (!hideWeek && !disabled && (0, _spauiUtils.isFunction)(onChange)) {
        if (data) {
          var year = data.year,
              month = data.month,
              date = data.date;
          var selectDate = (0, _utils.formatDate)(new Date(year, month, date)); // 重新选中时清空hover状态

          this.setState({
            hoverWeekDays: []
          });

          if (type === 'single') {
            this.setState({
              selectDate: selectDate
            });
          } else if (type === 'start') {
            this.setState({
              selectStartDate: selectDate,
              selectEndDate: ''
            });
          } else if (type === 'end') {
            this.setState({
              selectStartDate: '',
              selectEndDate: selectDate
            });
          }

          data.disableWeekDays = disableWeekDays;
        }

        onChange(event, type, data); // 如果选择的是上下个月，面板需要切换

        if ((0, _spauiUtils.isFunction)(onYearAndMonthChange)) {
          onYearAndMonthChange(event, data);
        }
      }
    } // 当鼠标 hover 到某一天

  }, {
    key: "onMouseEnterDay",
    value: function onMouseEnterDay() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var year = data.year,
          month = data.month,
          date = data.date;
      var _this$props8 = this.props,
          firstDayOfWeek = _this$props8.firstDayOfWeek,
          endDayOfWeek = _this$props8.endDayOfWeek,
          changeHoverDate = _this$props8.changeHoverDate;
      var hoverDate = (0, _utils.formatDate)(new Date(year, month, date));
      var hoverWeekDays = (0, _utils.getCurrentWeekDays)(hoverDate, firstDayOfWeek, endDayOfWeek);
      this.setState({
        hoverWeekDays: hoverWeekDays
      });
      changeHoverDate && changeHoverDate(year, month, date);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var data = this.getData();
      var _this$props9 = this.props,
          _this$props9$classNam = _this$props9.classNameMap,
          classNameMap = _this$props9$classNam === void 0 ? {} : _this$props9$classNam,
          panelWeekStart = _this$props9.panelWeekStart,
          locale = _this$props9.locale,
          fixedTips = _this$props9.fixedTips;
      var weekList = panelWeekStart === 0 ? locale.weekListMapBySunDay : locale.weekListMapByMonDay;
      var showTips = fixedTips;
      return _react["default"].createElement("div", {
        className: classNameMap.DatePickerDateItemClassName
      }, _react["default"].createElement("ul", {
        className: "clearfix ".concat(classNameMap.DatePickerWeekListClassName)
      }, weekList.map(function (item) {
        return _react["default"].createElement("li", {
          key: item
        }, item);
      })), _react["default"].createElement("ul", {
        className: "clearfix ".concat(classNameMap.DatePickerDateListClassName)
      }, data.map(function (item, index) {
        var _classNames;

        var dateView = _react["default"].createElement("div", null, _react["default"].createElement("span", {
          hidden: true
        }, item.disableWeekDays && item.disableWeekDays.join(',')), _react["default"].createElement("a", {
          className: (0, _classnames["default"])({
            'spaui-datepicker-pointer': (0, _spauiUtils.isUndefined)(item.disabled) || !item.disabled
          }),
          key: item,
          onClick: function onClick(event) {
            return _this3.handleChange(event, (0, _spauiUtils.objectAssign)({}, item));
          },
          onMouseEnter: function onMouseEnter() {
            return _this3.onMouseEnterDay(item);
          }
        }, item.date));

        var tipContent = showTips && (item.on || item.among) ? fixedTips : item.tips;
        var minWidth = showTips && (item.on || item.among) ? 167 : 110;
        return _react["default"].createElement("li", {
          key: "".concat(item.year, "-").concat(item.month, "-").concat(item.date, "-").concat(index),
          className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, classNameMap.DatePickerLastMonthDateItemClassName, item.lastMonth), _defineProperty(_classNames, classNameMap.DatePickerNextMonthDateItemClassName, item.nextMonth), _defineProperty(_classNames, classNameMap.DatePickerDateItemDisabledClassName, item.disabled && !item.on || item.hideWeek), _defineProperty(_classNames, classNameMap.DatePickerDateItemSelectedClassName, item.on && !item.hover), _defineProperty(_classNames, classNameMap.DatePickerStartDateItemClassName, item.startDate), _defineProperty(_classNames, classNameMap.DatePickerEndDateItemClassName, item.endDate), _defineProperty(_classNames, classNameMap.DatePickerAmongDateItemClassName, item.among), _classNames)),
          style: {
            borderTopLeftRadius: item.needLeftRadius ? 2 : 0,
            borderBottomLeftRadius: item.needLeftRadius ? 2 : 0,
            borderTopRightRadius: item.needRightRadius ? 2 : 0,
            borderBottomRightRadius: item.needRightRadius ? 2 : 0,
            backgroundColor: item.among && !item.hover && 'rgba(41, 107, 239, 0.2)' || item.hover && ' #EDEFF2',
            color: item.hover && '#333'
          }
        }, item.hover ? _react["default"].createElement(_spauiPopover.OverlayTrigger, {
          trigger: "hover",
          showDelayTime: 1000,
          placement: "bottom",
          alignment: "center",
          overlay: _react["default"].createElement(_spauiPopover.PopOver, {
            style: {
              zIndex: 99999,
              padding: 0,
              minWidth: minWidth,
              maxWidth: minWidth
            }
          }, tipContent)
        }, dateView) : dateView);
      })));
    }
  }]);

  return WeekPanel;
}(_react.PureComponent);

_defineProperty(WeekPanel, "propTypes", {
  type: _spauiUtils.PropTypes.string,
  year: _spauiUtils.PropTypes.number,
  month: _spauiUtils.PropTypes.number,
  firstDayOfWeek: _spauiUtils.PropTypes.number,
  endDayOfWeek: _spauiUtils.PropTypes.number,
  dateData: _spauiUtils.PropTypes.object,
  startData: _spauiUtils.PropTypes.object,
  endData: _spauiUtils.PropTypes.object,
  onChange: _spauiUtils.PropTypes.func,
  onYearAndMonthChange: _spauiUtils.PropTypes.func,
  startDateDisabled: _spauiUtils.PropTypes.bool,
  endDateDisabled: _spauiUtils.PropTypes.bool,
  hoverYear: _spauiUtils.PropTypes.number,
  hoverMonth: _spauiUtils.PropTypes.number,
  hoverDate: _spauiUtils.PropTypes.number,
  changeHoverDate: _spauiUtils.PropTypes.func,
  fixedNumber: _spauiUtils.PropTypes.number,
  // 默认选中前几周
  fixedTips: _spauiUtils.PropTypes.string // 默认选中提示popover

});

_defineProperty(WeekPanel, "defaultProps", {
  type: '',
  dateData: {},
  startData: {},
  endData: {},
  firstDayOfWeek: 1,
  startDateDisabled: false,
  endDateDisabled: false
});

var _default = WeekPanel;
exports["default"] = _default;